import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import moment from 'moment';
import 'moment/locale/fr'; 
import { RRule } from 'rrule';

import Button from 'react-bootstrap/Button';
import Badge from 'react-bootstrap/Badge';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import fr from 'date-fns/locale/fr';

// font awesome icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretLeft, faCaretRight, faCalendar } from '@fortawesome/free-solid-svg-icons';

const API_KEY = 'AIzaSyDM9oCumOpyRDeAdYyL7ebcRc_lqsWwpc4';
const CALENDAR_ID = 'petit.train.paimpol@gmail.com';

const EventList = () => {
    const [events, setEvents] = useState([]);
    const [startDate, setStartDate] = useState(moment().startOf('day'));
    const [showCalendar, setShowCalendar] = useState(false);

    const buttonRef = useRef(null);

    useEffect(() => {
        fetchEvents();
    }, [startDate]);

    const fetchEvents = async () => {
        try {
            const endDate = moment(startDate).add(4, 'days');

            const response = await axios.get(
                `https://www.googleapis.com/calendar/v3/calendars/${CALENDAR_ID}/events`,
                {
                    params: {
                        key: API_KEY,
                        timeMin: startDate.toISOString(),
                        timeMax: endDate.toISOString(),
                        singleEvents: true,
                    }
                }
            );

            const events = response.data.items;

            // filter events to remove private ones
            const publicsEvents = events.filter(event => {
                return event.visibility !== 'private';
            });

            // group events by day
            const groupedEvents = groupEventsByDay(publicsEvents);
            setEvents(groupedEvents);
        } catch (error) {
            console.error('Error fetching events:', error);
        }
    };

    const groupEventsByDay = (events) => {
        const allEvents = [];
      
        events.forEach((event) => {
            const startDate = moment(event.start.dateTime || event.start.date).format('YYYY-MM-DD');
            const endDate = moment(event.end.dateTime || event.end.date).format('YYYY-MM-DD');
      
            if (event.recurrence) {
                const recurrenceRule = event.recurrence[0].substring(6);
                const rrule = new RRule({
                    freq: RRule.WEEKLY,
                    dtstart: new Date(event.start.dateTime || event.start.date),
                    ...(RRule.fromString(recurrenceRule).origOptions || {}),
                });
                const occurrenceDates = rrule.all();
      
                occurrenceDates.forEach((date) => {
                    const formattedDate = moment(date).format('YYYY-MM-DD');
                    allEvents.push({
                        ...event,
                        start: {
                            ...event.start,
                            dateTime: date.toISOString(),
                            date: null,
                        },
                        end: {
                        ...event.end,
                        dateTime: moment(event.end.dateTime || event.end.date).add(date.diff(event.start.dateTime || event.start.date), 'ms').toISOString(),
                        date: null,
                        },
                        recurring: true,
                        formattedDate,
                    });
                });
            } else {
                allEvents.push({
                    ...event,
                    formattedDate: startDate,
                });
            }
        });
      
        allEvents.sort((a, b) => {
            const startDateA = moment(a.start.dateTime || a.start.date);
            const startDateB = moment(b.start.dateTime || b.start.date);
            return startDateA.diff(startDateB);
        });
      
        const groupedEvents = {};
      
        allEvents.forEach((event) => {
            const formattedDate = event.formattedDate;
            if (!groupedEvents[formattedDate]) {
                groupedEvents[formattedDate] = [];
            }
            groupedEvents[formattedDate].push(event);
        });
      
        return groupedEvents;
    };
    
    const handlePreviousWeek = () => {
        setStartDate(moment(startDate).subtract(4, 'days'));
    };
    
    const handleNextWeek = () => {
        setStartDate(moment(startDate).add(4, 'days'));
    };

    const handleShowCalendar = () => {
        setShowCalendar(!showCalendar);
    };

    const handleDateSelect = (date) => {
        // Do something with the selected date
        setStartDate(date);
        setShowCalendar(false);
    };

  return (
    <div className="content">
        <div className="horaires-navigation-buttons">
            <Button variant="primary" onClick={handlePreviousWeek}><FontAwesomeIcon icon={faCaretLeft} /> Horaires précédents</Button>
            <Button variant="primary" onClick={handleNextWeek}>Horaires suivants <FontAwesomeIcon icon={faCaretRight} /></Button>
            <div style={{ position: 'relative', display: 'inline-block' }}>
                <Button onClick={handleShowCalendar} ref={buttonRef}><FontAwesomeIcon icon={faCalendar} /></Button>
                {showCalendar && (
                    <div
                        style={{
                            position: 'absolute',
                            top: buttonRef.current.offsetTop + buttonRef.current.offsetHeight,
                            left: buttonRef.current.offsetLeft,
                            zIndex: 9999
                        }}
                    >
                        <DatePicker 
                            selected={null} 
                            onChange={handleDateSelect} 
                            inline 
                            locale={fr}
                        />
                    </div>
                )}
            </div>
        </div>
        <hr />
        <h2>Horaires du {moment(startDate).locale('fr').format('dddd D MMMM')} au {moment(startDate).add(3, 'days').locale('fr').format('dddd D MMMM')}</h2>
        <hr />
        {Object.entries(events).map(([date, eventsByDay]) => (
            <div key={date} className="horaire-day">
                <h3>{moment(date).format('dddd DD MMMM')}</h3>
                <ul className="horaires">
                    {eventsByDay.sort((a, b) => {
                        const startDateA = moment(a.start.dateTime || a.start.date);
                        const startDateB = moment(b.start.dateTime || b.start.date);
                        return startDateA.diff(startDateB);
                    }).map((event) => (
                        <li key={event.id}>
                            {
                                moment(event.start.dateTime, "YYYY-MM-DD").isValid() ?
                                    <>
                                    <Badge>{moment(event.start.dateTime).locale('fr').format('HH:mm')}</Badge> : {event.summary}
                                    </>
                                :
                                    <>
                                    <Badge>Toute la journée</Badge> : {event.summary}
                                    </>
                            }
                            
                        </li>
                    ))}
                </ul>
            </div>
        ))}
    </div>
  );
};

export default EventList;
